export const VN_TIME_OPTIONS: readonly string[] = Array.from({ length: 96 }, (_, index) => {
  const totalMinutes = index * 15;
  const hours = Math.floor(totalMinutes / 60)
    .toString()
    .padStart(2, '0');
  const minutes = (totalMinutes % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}`;
});

export function vnTimeToUtcCron(vnTime: string): string {
  const [vnHour = '0', vnMinute = '0'] = vnTime.split(':');
  const utcHour = (Number(vnHour) - 7 + 24) % 24;
  return `${Number(vnMinute)} ${utcHour} * * *`;
}

export function utcCronToVnTime(cron: string): string {
  const [minute, hour] = cron.trim().split(/\s+/);
  const utcHour = Number(hour);
  const utcMinute = Number(minute);

  if (!Number.isInteger(utcHour) || !Number.isInteger(utcMinute)) return '';
  if (utcHour < 0 || utcHour > 23 || utcMinute < 0 || utcMinute > 59) return '';
  if (utcMinute % 15 !== 0) return '';

  const vnHour = (utcHour + 7) % 24;
  return `${vnHour.toString().padStart(2, '0')}:${utcMinute.toString().padStart(2, '0')}`;
}
